import { ContactContent } from "@/components/contact-content"

export default function ContactPage() {
    return <ContactContent />
}
